import React from "react";
import "../styles/Dashboard.css";

const TankStatus = ({ tankData }) => {
    if (!tankData || tankData.length === 0) {
        return <p>⚠️ Data tangki tidak tersedia...</p>;
    }

    // 🔍 Filter Data Terbaru per Tangki (berdasarkan tank_id)
    const latestTankData = tankData.reduce((acc, tank) => {
        const existing = acc[tank.tank_id];
        if (!existing || new Date(tank.timestamp) > new Date(existing.timestamp)) {
            acc[tank.tank_id] = tank;
        }
        return acc;
    }, {});

    const latestDataArray = Object.values(latestTankData);

    return (
        <div className="tank-status-container">
            <h3>🚰 Status Tangki Air Terbaru</h3>
            {latestDataArray.map((tank) => {
                const { tank_id, tank_name, water_level_cm, volume, capacity, height_cm, timestamp } = tank;
                const percentage = Math.min((volume / capacity) * 100, 100);

                return (
                    <div key={tank_id} className="tank-card">
                        <h4>🛢️ {tank_name} ({tank_id})</h4>
                        <div className="tank-info">
                            <p>📅 Terakhir Update: {new Date(timestamp).toLocaleString()}</p>
                            <p>📏 Ketinggian Air: {water_level_cm} cm dari {height_cm} cm</p>
                            <p>💧 Volume: {volume} L dari {capacity} L</p>
                            <p>📊 Kapasitas: {percentage.toFixed(1)}%</p>
                            <div className="tank-bar">
                                <div
                                    className="tank-fill"
                                    style={{ height: `${percentage}%` }}
                                ></div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TankStatus;
